import { btoa, encrypt, decrypt } from '../../utils/common/common';

export default class Auth {
    login = (email, password, callback) => {
        fetch('/identity/users/auth', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Basic ${btoa(`${email}:${password}`)}`,
            },
        }).then(callback);
    }

    setSession = (data) => {
        for (const k in data) {
            if (Object.hasOwnProperty.call(data, k)) {
                localStorage.setItem(k, encrypt(data[k]));
            }
        }
    }

    getSession = sessionKey => decrypt(localStorage.getItem(sessionKey) || '');

    logout = () => {
        localStorage.removeItem('qc_act');
        localStorage.removeItem('qc_email');
        localStorage.removeItem('qc_uid');
    }

    isAuthenticated = () => localStorage.getItem('qc_act') !== null

    verifyToken = async () => {
        const accessToken = this.getSession('qc_act');
        if (!accessToken) return false;
        const verifyRes = await fetch('/identity/users/verify-token', {
            method: 'GET',
            headers: {
                'x-access-token': accessToken
            }
        });
        return verifyRes.status === 200;
    }

    getProfile = async () => {
        const accessToken = this.getSession('qc_act');
        if (!accessToken) return false;
        let res = await fetch('/identity/users/profile', {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${accessToken}`,
            }
        });
        if (res.status !== 200) return null
        res = await res.json()
        return res.result
    }
}